import { MapPin, Layers, Frame, BrickWall, Zap, Droplets, LayoutGrid, PaintBucket, Building2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BUILD_STAGES } from "@/data/content";

const STAGE_ICONS = [MapPin, Layers, Frame, BrickWall, Zap, Droplets, LayoutGrid, PaintBucket, Building2];

export const BuildTimeline = () => (
    <div className="relative mx-auto max-w-xl pl-14" data-testid="build-timeline">
        <div className="absolute bottom-4 left-[22px] top-4 w-px bg-white/12" aria-hidden />
        {BUILD_STAGES.map((s, i) => {
            const Icon = STAGE_ICONS[i];
            return (
                <Reveal key={s.key} delay={0.03}>
                    <div className="relative mb-6 rounded-2xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-sm"
                        data-testid={`build-stage-${i}`}>
                        <span className="absolute -left-14 top-5 flex h-11 w-11 items-center justify-center rounded-full border border-flame/50 bg-omsivo-deep">
                            <Icon className="h-5 w-5 text-flame" />
                        </span>
                        <p className="font-mono text-[9px] uppercase tracking-[0.28em] text-flame">
                            Stage {String(i + 1).padStart(2, "0")} / 09
                        </p>
                        <h3 className="mt-1.5 font-display text-lg font-extrabold uppercase tracking-[0.08em] text-white">{s.key}</h3>
                        <p className="mt-1.5 text-sm leading-relaxed text-white/60">{s.text}</p>
                    </div>
                </Reveal>
            );
        })}
        <Reveal>
            <p className="relative mt-2 rounded-2xl border border-flame/40 bg-flame/10 p-6 text-center font-display text-lg font-black uppercase tracking-wide text-white">
                From your first idea<br /><span className="text-flame">to your final key.</span>
            </p>
        </Reveal>
    </div>
);
